import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
//===--- Main
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
//===--- Icons
import Logo from '../images/logo.png';
import { IoSearchOutline } from 'react-icons/io5';
//===--- Data
import MENU from './data/menuItems';

export default function NavBar(props) {
  const [formData, setFormData] = useState({
    search: ""
  })
  function handleChange(event) { 
    setFormData(prevFormData => {
        return {
            ...prevFormData,
            [event.target.name]: event.target.value
        }
    })
  }

  const navigate = useNavigate();
  const handleSearch = (elem) => {
    elem.preventDefault();

    const FullMenu = MENU.flatMap(category => Object.values(category).flat());
    const foundItemIndex = FullMenu.findIndex(item => item.title === formData.search);

    if (foundItemIndex !== -1) {
      const foundItem = FullMenu[foundItemIndex];
      navigate(`/menu/product?&item=${foundItem.key}&other=false`)
    } else {
      alert(`Sorry, we couldn't find any results for "${formData.search}". Please try searching with the full item names.`);
    }
  };

  return (
    <>
      {['md'].map((expand) => (
        <Navbar key={expand} expand={expand} className='bg-body-primary mb-3 primary-navbar' sticky='top'>
          <Container>
            <Navbar.Brand href='#/'>
              <img
                alt='Bubblery Logo'
                src={Logo}
                width='50'
                height='50'
                className='d-inline-block align-top'
              /></Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} className='bg-transparent border-0'/>
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement='end'
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className='justify-content-start flex-grow-1 pe-3'>
                  <Nav.Link href='#/menu'>Menu</Nav.Link>
                  <Nav.Link href='#/rewards'>Rewards</Nav.Link>
                  <Nav.Link href='#/gift_cards'>Gift Cards</Nav.Link>
                </Nav>
                <Form className='d-flex' onSubmit={handleSearch}>
                  <IoSearchOutline className='ico'/>
                  <Form.Control
                    type='search'
                    placeholder='Search'
                    className='me-2 bg-transparent border-0 border-bottom border-dark rounded-0'
                    aria-label='Search'
                    value={formData.search}
                    name='search'
                    onChange={handleChange}
                  />
                </Form>
                {props.screenSize ? <>
                    {props.isSignedIn ? <>
                    <Button onClick={()=>(props.setSignedIn(false))} variant='outline-dark' size='sm'>Log Out</Button>
                    <h6 className='user'>Hello, {props.username}</h6>
                    </> : <>
                    <Button href='#/account' variant='outline-dark' size='sm'>Log in</Button>
                    <Button href='#/create_account' variant='dark' size='sm'>Sign up</Button>
                  </>}
                </> : <>
                  {props.isSignedIn ? <>
                    <Button onClick={()=>(props.setSignedIn(false))} variant='outline-dark'>Log Out</Button>
                    <h6 className='user'>Hello, {props.username}</h6>
                    </> : <>
                    <Button href='#/account' variant='outline-dark'>Log in</Button>
                    <Button href='#/create_account' variant='dark'>Sign up</Button>
                  </>}
                </>}
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
          <div className='bg-div bg-body-secondary'></div>
        </Navbar>
      ))}
    </>
  );
}